import React, { useState, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { check_user_invoice, update_user_invoices } from "../../redux/actions/payment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function EditInvoice({ user, update_user_invoices, updateList, currentInvoice }) {
    const [open, setOpen] = useState(false);
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();


    const messages = {
        required: "Este campo es obligatorio",
        minLength: "No puede ingresar menor caracteres de lo establecido",
        maxLength: "No puede ingresar más caracteres en este campo",
        espacioBlanco: 'No es permitido espacios en blanco',
        requiredColor: 'Debe seleccionar un color',
        aceptaNumeros: 'Solo se acepta números en este campo',
        aceptaLetra: 'Solo se acepta letras en este campo'
    };

    const patterns = {
        espacioBlanco: /^(?!\s)/,
        aceptaNumeros: /^[0-9,-]+$/,
        aceptaLetra: /^[A-Za-z\s]+$/,
    };

    useEffect(() => {
        if (currentInvoice) {
            setValue("name", currentInvoice.name || "");
            setValue("nit", currentInvoice.nit || "");
        }
    }, [currentInvoice, setValue]);



    const onSubmit = async (formInfo) => {
        reset();
        const data = {
            "invoice_id": currentInvoice.id,
            "razon": formInfo.name,
            "nit": formInfo.nit,
        };

        await update_user_invoices(data)
        let dataUpdateList = {
            'user_id': user.id
        }
        updateList(dataUpdateList);
        setTimeout(() => {
            setOpen(false);
        }, 1000);
        console.log(data)
    }

    return (
        <>
            <button
                onClick={() => {
                    if (currentInvoice) {
                        setValue("name", currentInvoice.name || "");
                        setValue("nit", currentInvoice.nit || "");
                    }
                    setOpen(true);
                }}
                className="bg-white text-ecoprimary1 px-2 py-1 rounded-3 text-sm transition duration-200 d-flex align-items-center"
            >
                <FontAwesomeIcon icon={faEdit} className="me-1" /> Editar
            </button>

            <Transition show={open} as={React.Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0 bg-bgblack bg-opacity-30" />
                    <div className="fixed inset-0 flex items-center justify-center p-4 ">
                        <Dialog.Panel
                            className="w-full max-w-2xl flex flex-col rounded-lg bg-white shadow-xl transition-all overflow-hidden">

                            <div className="bg-ecoprimary1 text-white py-2 text-center font-semibold text-lg">
                                Editar datos de facturación
                            </div>

                            <div className="flex-1 overflow-y-auto px-4 py-2">
                                <form id="post_location" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div>
                                            <label className="block text-sm font-bold mb-1">Nombre:</label>
                                            <input
                                                className="form-control w-full"
                                                type="text"
                                                placeholder="Nombre"
                                                {...register("name", {
                                                    required: {
                                                        value: true,
                                                        message: messages.required,
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: messages.minLength
                                                    },
                                                    maxLength: {
                                                        value: 100,
                                                        message: messages.maxLength
                                                    },
                                                    pattern: {
                                                        value: patterns.espacioBlanco,
                                                        message: messages.espacioBlanco
                                                    },
                                                }
                                                )}
                                            />
                                            {errors.name && <small
                                                className="text-red-600">{errors.name.message}</small>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-bold mb-1">NIT:</label>
                                            <input
                                                className="form-control w-full"
                                                type="number"
                                                placeholder="NIT"
                                                {...register("nit", {
                                                    required: {
                                                        value: true,
                                                        message: messages.required,
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: messages.minLength
                                                    },
                                                    maxLength: {
                                                        value: 100,
                                                        message: messages.maxLength
                                                    },
                                                    pattern: {
                                                        value: patterns.espacioBlanco,
                                                        message: messages.espacioBlanco
                                                    },
                                                }
                                                )}
                                            />
                                            {errors.nit &&
                                                <small className="text-red-600">{errors.nit.message}</small>}
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="border-t-2 px-4 py-3 flex items-center justify-end">
                                <div className="flex items-center gap-2">
                                    <button
                                        type="button"
                                        onClick={() => setOpen(false)}
                                        className="bg-blue-100 text-ecoprimary1 py-2 px-3 rounded text-sm"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit" form="post_location"
                                        className="bg-ecoprimary1 text-white py-2 px-3 rounded text-sm"
                                    >
                                        Registrar
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}

const mapStateToProps = state => ({
    locations: state.Location.locations,
    location: state.Location.location,
    user: state.Auth.user,
});

export default connect(mapStateToProps, {
    check_user_invoice,
    update_user_invoices
})(EditInvoice);
